// Sub-navigation of the prototype's Supervisor view: the wallboard, and (Phase 3) the AI QA review and AI report.

import { href } from '../router.ts';
import { useSession } from '../session.tsx';

export function SupervisorNav({ current, pendingQa }: { current: 'wallboard' | 'qa' | 'aiReport'; pendingQa?: number | null }) {
  const s = useSession();
  if (!s.config.features.agent) return null;
  const item = (k: typeof current, to: string, label: string, extra?: number | null) => (
    <a href={to} className={current === k ? 'on' : ''} aria-current={current === k ? 'page' : undefined}>
      {label}
      {extra ? <> <span className="n hot">{extra}</span></> : null}
    </a>
  );
  return (
    <nav className="subnav" aria-label="Supervisor">
      {item('wallboard', href.wallboard(), 'Wallboard')}
      {item('qa', href.qa(), 'AI QA review', pendingQa)}
      {item('aiReport', href.aiReport(), 'AI report')}
    </nav>
  );
}
